import { Navigate } from "react-router-dom";
import './travel.css'

function Travel() {

    const COLOR_1 = "rgb(226, 253, 194)"
    const COLOR_2 = "rgb(246, 255, 236)"
    // const COLOR_3 = "rgb(190, 199, 250)"
    // const COLOR_4 = "rgb(239, 242, 254)"

    const AIRPORT_LINK = "https://www.google.com/search?q=Flights+to+Boston+Logan+International+Airport";
    const TRAIN_LINK = "https://www.google.com/search?q=Trains+to+Boston+South+Station";
    const HIGHWAY_LINK = "https://www.google.com/maps/dir//Hampshire+House,+84+Beacon+St,+Boston,+MA+02108/";
    const HARBOR_LINK = "https://www.bostonharbornow.org/what-we-do/explore/gettingaround/";
    const HOME_LINK = "https://www.google.com/maps/place/68+Porter+Rd,+Cambridge,+MA+02140/";
    const PORTER_SQUARE_HOTELS_LINK = "https://www.google.com/maps/search/Hotels+in+Porter+Square,+Cambridge,+MA/";
    const BOSTON_HOTELS_LINK = "https://www.google.com/maps/search/Hotels+near+Hampshire+House,+boston";
    const CONDOS_LINK = "https://www.google.com/search?q=Boston+Condos";


    if (window.sessionStorage.getItem("loggedIn") !== "TRUE") {
        return <Navigate to="/" />
    }

    function TravelInfoCard(title: string, description: string, colorCode: string, linkHref: string, imageSrc: string = "",) {
        return (
            <>
                <a href={linkHref} className="link" target="blank">
                <div className="travel-info-card">
                    <div style={{
                        backgroundColor: colorCode,
                        borderRadius: "20px",
                        paddingLeft: "10px",
                        paddingBottom: "10px",
                        paddingRight: "50px",
                        height: "150px",
                        alignContent: "center",
                    }}>
                        <p className="travel-heading">{title}</p>
                        <p className="travel-subheading">{description}</p>
                    </div>

                    {imageSrc !== "" ? <img src={imageSrc} alt={`${title} - ${description}`} /> : <></>}
                </div>
                </a>
            </>
        )
    }

    return (
        <div className="Travel-container">
            <div className="Travel-content">
                <div className="Travel-column">
                    <p className="Column-header">How to Get Here</p>
                    {TravelInfoCard("Boston Logan Airport", "A beautiful international hub", COLOR_1, AIRPORT_LINK)}
                    {TravelInfoCard("South Station", "The twain", COLOR_2, TRAIN_LINK)}
                    {TravelInfoCard("I-84 to I-90", "Scranton to Boston. It's probably slightly different coming from Philly.", COLOR_1, HIGHWAY_LINK)}
                    {TravelInfoCard("Boston Harbor", "One if by land, two if by sea. If you're coming from Hingham or Provincetown, come to us by boat!", COLOR_2, HARBOR_LINK)}

                </div>
                <div className="Travel-column">
                    <p className="Column-header">How to Stay Here</p>
                    {TravelInfoCard("68 Porter Rd", "Just kidding! We already live here :)", COLOR_2, HOME_LINK)}
                    {TravelInfoCard("Porter Square Hotels", "Hotels around where we live", COLOR_1, PORTER_SQUARE_HOTELS_LINK)}
                    {TravelInfoCard("Boston Hotels", "There are a lot of them", COLOR_2, BOSTON_HOTELS_LINK)}
                    {TravelInfoCard("Buy a condo!", "Staying for the wedding? Why not stay forever? Say \"I do\" to Beantown.", COLOR_1, CONDOS_LINK)}
                </div>
            </div>
        </div>
    )
}

export default Travel;